import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from './../../../config/axiosConfig/axios';
import { Api } from '../../../config/apiList/api'
import { Row, Col, Table, Input, Button, notification,Pagination } from 'antd';
import './userList.css'
import { SpinnerDotted } from 'spinners-react';
import Mod from "../userDetails/EditUserDetail";
import UserDetailModal from "./userDetailModal";


function UserList() {
    const [userList, setUserList] = useState("");
    const [step, setStep] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);

    function changeState(newUserList){
        setUserList(newUserList)
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }
    
    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    useEffect( () => {
        // console.log(`${Api}user-list-panel?page=${pageNumber}`);
        // console.log({token: localStorage.getItem("Token")});

        Axios.get(`${Api}user-list-panel?page=${pageNumber}&size=20&search=${search}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    setUserList(data.data.data);
                    setTotalPage(data.data.total_pages);
                    // console.log("totalPages: ", data.data.total_pages);
                    setStep(1);

                    // console.log("userList", data)
                }

            })
            .catch((error) => {
                // console.log(`err is ${error}`);
            });
    }, [pageNumber]);



    const searching = () => {
        if (search.length !== 0) {
            Axios.get(`${Api}user-list-panel?search=${search}&size=20`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        setUserList(data.data.data);
                        setTotalPage(data.data.total_pages);
                        setStep(1);

                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام کاربر را وارد نمایید")
        }
    }

    const columns = [
        {
            title: 'شناسه',
            dataIndex: "id",

        },
        {
            title: 'کد املاک',
            dataIndex: 'codeAmlak',

        },
        {
            title: 'نام و نام خانوادگي',
            dataIndex: 'moshaver',

        },
        {
            title: 'موبايل',
            dataIndex: 'tel_moshaver',

        },

        {
            title: 'وضعیت ورود',
            render: (e) => {return e.isLogin ===true ?<p style={{backgroundColor:"green"}}>وارد شده</p>:<p style={{backgroundColor: "red"}}>وارد نشده</p>},

        },

        // {
        //     title: 'کد فعالسازی',
        //     render: (e) => {return <div>
        //         <p style={{fontFamily: "arial"}}>{e.licence? "...." + e.licence.substring(0,20): "...."}</p>
        //         <Button onClick={async event => {
        //
        //
        //                 await navigator.clipboard.writeText(e.licence);
        //                 notification.open({
        //                     message: "انجام شد",
        //                     description: "کد فعالسازی کپی شد!",
        //                     style: {
        //                         background: "#43a047",
        //                         color: "white",
        //                         fontFamily: "IRANSansMobileFaNum",
        //                         borderRadius: "5px",
        //                     }
        //                 })
        //
        //         }} style={{  backgroundColor: "white",
        //             color: "#3174ff",
        //             border: "2px solid #ffffff" /* Green */}}>کپی</Button>
        //     </div>}
        //     // dataIndex: 'licence',
        //
        // },
        {
            title: "جزئیات",
            render: (e) => {
                // console.log("iiid",e.id)
                return <UserDetailModal id={e.id}/>
            }
        },

        {
            title: 'عمليات',
            render: (e) => {
                return  <Mod userId={e.id} codeAmlak={e.codeAmlak} isLogin={e.isLogin} changeUserList={changeState} pageNumber={pageNumber}/>
            }

        },
    ];


    switch (step) {
        case 0:
            return <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

        case 1:
            return (
                userList
                    ? <>
                        <Row style={{ background: 'white', marginBottom: '10px' }}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                                <Input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    id="userSerachInput"
                                    placeholder='برای جستجو نام مشاور یا کد املاک را وارد نمایید...'
                                />
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                                <Button onClick={searching} id='userSearchButton'>جستجوی کاربر</Button>
                            </Col>
                        </Row>

                        <Table id='userTableList' columns={columns} dataSource={userList} pagination={false} />
                        <Row style={{width:'100%', justifyContent:'center'}}>
                    <Pagination 
                    style={{direction:'ltr',marginTop:"20px"}}
                    current={pageNumber} 
                    total={totalPage * 10}
                    pageSize={10}
                    onChange={
                        (e)=>{
                            setPageNumber(e)
                        }
                    } />
                </Row>

                    </>
                    :
                    <>
                        <p className='orderColumeText' >كاربري در حال حاضر براي نمايش وجود ندارد</p>
                    </>
            )



    }
}
export default UserList;

